import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiAccordionDetails, {
  AccordionDetailsProps,
} from '@material-ui/core/AccordionDetails';

const AccordionDetails: React.FC<AccordionDetailsProps> = withStyles(
  (theme) => ({
    root: {
      padding: 0,
      flexDirection: 'column',
    },
  }),
)(MuiAccordionDetails);

export default AccordionDetails;
